<template>
  <router-link
    active-class="active-menu-item"
    :to="to"
    class="group flex items-center rounded-md py-2 px-4 transition-colors duration-150 ease-out-quart hover:bg-neutral-100/70"
  >
    <component
      :is="getNavigationIcon(icon)"
      class="mr-2 h-5 w-5 text-neutral-700 transition-colors duration-150 ease-out-quart group-hover:text-primary-500"
    />
    <span
      class="text-sm font-normal tracking-wide text-neutral-700 transition-colors duration-150 ease-out-quart group-hover:text-primary-500"
    >
      {{ te(name) ? t(name) : name }}
    </span>
  </router-link>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { getNavigationIcon } from './NavigationIcons';

interface Props {
  name: string;
  to: string;
  icon?: string;
}

withDefaults(defineProps<Props>(), {
  icon: ''
});

const { t, te } = useI18n();
</script>

<style lang="css" scoped>
a:hover {
  @apply fill-primary-500;
}
</style>
